import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import Link from '@material-ui/core/Link'
import { useTheme } from '@material-ui/core/styles'
import { IconButtonCtaArrow } from '@components/atoms/icons'
import { useStyles } from './academy.styles'

const QuickLinks = ({ imageUrl, links }) => {
  const theme = useTheme()
  const classes = useStyles()
  const handleInternalNavClick = (anchor) => {
    // assuming anchor has '#some-id' format
    const sectionToScroll = document.getElementById(anchor.slice(1))
    if (sectionToScroll) {
      sectionToScroll.scrollIntoView({ behavior: 'smooth' })
    }
  }

  // eslint-disable-next-line react/prop-types
  const ExternalLink = ({ url, title }) => (
    <Link href={url} target="_blank" className={classes.quicklink} key={title}>
      <Box my={2} display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="body1" className={classes.quicklinkText}>
          {title}
        </Typography>
        <IconButtonCtaArrow color={theme.palette.primary.main} />
      </Box>
    </Link>
  )

  // eslint-disable-next-line react/prop-types
  const InternalLink = ({ url, title }) => (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/interactive-supports-focus
    <div role="button" className={classes.quicklink} key={title} onClick={() => handleInternalNavClick(url)}>
      <Box my={2} display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="body1" className={classes.quicklinkText}>
          {title}
        </Typography>
        <IconButtonCtaArrow color={theme.palette.primary.main} />
      </Box>
    </div>
  )

  return (
    <Box className={classes.quickLinksContainer}>
      {imageUrl && (
        <Box
          data-testid="image-container"
          style={{
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: 'cover',
            height: '145px',
            borderRadius: '8px 8px 0px 0px',
          }}
        />
      )}
      <Box px={4.5} py={3.25}>
        <Typography variant="h5" style={{ color: theme.palette.secondary.light }} gutterBottom>
          Quick Links
        </Typography>
        <Divider style={{ backgroundColor: '#DBD2C1' }} />
        {links.map(link => (
          link.url.trim().startsWith('http') ? <ExternalLink {...link} /> : <InternalLink {...link} />
        ))}
      </Box>
    </Box>
  )
}

QuickLinks.propTypes = {
  imageUrl: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  })).isRequired,
}

export default QuickLinks
